module.exports = __webpack_public_path__ + "img/banner-recetario.18db153c.png";